import { Box, TextField } from '@mui/material'
import React from 'react'

type Range = { from: string; to: string }

type Props = {
	value: Range
	placeholder: string
	onChange: (value: Range) => void
}

const inputSx = {
	flex: 1,
	'& .MuiInputBase-root': {
		height: '100%',
		py: '3px',
	},
}

export const DateRangeFilter: React.FC<Props> = ({ value, placeholder, onChange }) => (
	<Box sx={{ display: 'flex', gap: 1, width: '100%' }} onClick={(e) => e.stopPropagation()}>
		<TextField
			type="date"
			variant="standard"
			size="small"
			value={value.from}
			onChange={(e) => onChange({ ...value, from: e.target.value })}
			onKeyDown={(e) => e.stopPropagation()}
			placeholder={placeholder}
			sx={inputSx}
		/>
		<TextField
			type="date"
			variant="standard"
			size="small"
			value={value.to}
			onChange={(e) => onChange({ ...value, to: e.target.value })}
			onKeyDown={(e) => e.stopPropagation()}
			sx={inputSx}
		/>
	</Box>
)
